import createIcon from '../../createIcon';

/**
 * @component @name TurnSlightLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMTYgNEg3LjVWOS42Nkg5LjVWNy40MUwxNC41IDEyLjQxVjIwSDE2LjVWMTIuNDJDMTYuNSAxMS44OSAxNi4yOSAxMS4zOCAxNS45MSAxMS4wMUwxMC45MSA2LjAxSDEzLjE2VjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnSlightLeft = createIcon('TurnSlightLeft', [
  [
    'path',
    {
      d: 'M13.16 4H7.5V9.66H9.5V7.41L14.5 12.41V20H16.5V12.42C16.5 11.89 16.29 11.38 15.91 11.01L10.91 6.01H13.16V4Z',
      key: '13a9aw',
    },
  ],
]);

export default TurnSlightLeft;
